var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"container\" style=\"padding-top: 24px;\">\n    <div class=\"row\">\n        <div class=\"col l6 offset-l3 s12\">\n            <a class=\"connect waves-effect waves-light btn btn-large grey darken-3\"\n               style=\"width: 100%;\">\n                <i class=\"fa fa-connect\"></i>\n                Connect\n            </a>\n            <p>以下のアカウントを追加します。</p>\n            <div class=\"accounts\"></div>\n        </div>\n    </div>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./jiji/ui/template/content/connect/index.hbs
// module id = 43
// module chunks = 0